import { SyncState } from '@/types/graphql';

export enum SyncDisplayState {
    SYNCED = 'SYNCED',
    FAILED = 'FAILED',
    PENDING = 'PENDING',
    NOT_YET_SYNCED = 'NOT_YET_SYNCED',
}

export const getSyncDisplayState = (
    state: SyncState,
    existsInExternalSystem: boolean,
): SyncDisplayState => {
    if (state === SyncState.FAILING) {
        return SyncDisplayState.FAILED;
    }
    if (state === SyncState.PENDING) {
        return SyncDisplayState.PENDING;
    }
    if (!existsInExternalSystem) {
        return SyncDisplayState.NOT_YET_SYNCED;
    }
    return SyncDisplayState.SYNCED;
};
